
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js